const resendEmail = {
  '¡Estás a un paso de empezar a postularte!': '¡Estás a un paso de empezar a postularte!',
  'Activá tu cuenta a través del email que te enviamos a ': 'Activa tu cuenta a través del email que te enviamos a ',
  '¿No lo recibiste?': '¿No lo recibiste?',
  'Ver trabajos': 'Ver trabajos',
}

export default resendEmail
